/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Aproval_Allow_ThisInputs */

const en_admin_ai_chat_aproval_allow_this = /** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow this?`)
};

/** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */
const de_admin_ai_chat_aproval_allow_this = en_admin_ai_chat_aproval_allow_this;

/** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */
const es_admin_ai_chat_aproval_allow_this = en_admin_ai_chat_aproval_allow_this;

/** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */
const fr_admin_ai_chat_aproval_allow_this = en_admin_ai_chat_aproval_allow_this;

/** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */
const nl_admin_ai_chat_aproval_allow_this = en_admin_ai_chat_aproval_allow_this;

/** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */
const it_admin_ai_chat_aproval_allow_this = en_admin_ai_chat_aproval_allow_this;

/** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_aproval_allow_this = en_admin_ai_chat_aproval_allow_this;

/** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */
const pl_admin_ai_chat_aproval_allow_this = en_admin_ai_chat_aproval_allow_this;

/** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */
const hu_admin_ai_chat_aproval_allow_this = en_admin_ai_chat_aproval_allow_this;

/** @type {(inputs: Admin_Ai_Chat_Aproval_Allow_ThisInputs) => LocalizedString} */
const ro_admin_ai_chat_aproval_allow_this = en_admin_ai_chat_aproval_allow_this;

/**
* | output |
* | --- |
* | "Allow this?" |
*
* @param {Admin_Ai_Chat_Aproval_Allow_ThisInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_aproval_allow_this = /** @type {((inputs?: Admin_Ai_Chat_Aproval_Allow_ThisInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Aproval_Allow_ThisInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_aproval_allow_this(inputs)
	if (locale === "de") return de_admin_ai_chat_aproval_allow_this(inputs)
	if (locale === "es") return es_admin_ai_chat_aproval_allow_this(inputs)
	if (locale === "fr") return fr_admin_ai_chat_aproval_allow_this(inputs)
	if (locale === "nl") return nl_admin_ai_chat_aproval_allow_this(inputs)
	if (locale === "it") return it_admin_ai_chat_aproval_allow_this(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_aproval_allow_this(inputs)
	if (locale === "pl") return pl_admin_ai_chat_aproval_allow_this(inputs)
	if (locale === "hu") return hu_admin_ai_chat_aproval_allow_this(inputs)
	return ro_admin_ai_chat_aproval_allow_this(inputs)
});
export { admin_ai_chat_aproval_allow_this as "admin.ai_chat.aproval_allow_this" }